import React, {Component} from 'react';
import {translate} from 'react-i18next';
import {Table} from 'react-bootstrap';
import moment from 'moment';
import swal from 'sweetalert';
import SvgIcon from 'react-icons-kit';
import {pencil2} from 'react-icons-kit/icomoon/pencil2';
import {bin} from 'react-icons-kit/icomoon/bin';
import {print} from 'react-icons-kit/fa/print';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import WaitingModal from '../../generics/WaitingModal';
import Help from '../../generics/help';

var Config = require('../../../config');

class DiscardUnitsList extends Component{
	constructor(props){
		super(props);

		this.filter = this.filter.bind(this);
		this.handleChange = this.handleChange.bind(this);
		this.newEntry = this.newEntry.bind(this);
		this.onUpdate = this.onUpdate.bind(this);
		this.getList = this.getList.bind(this);
		this.printFolioPDF = this.printFolioPDF.bind(this);
		this.directPrint = this.directPrint.bind(this);

		var aux_date = new Date();
		this.state = {
			filterText:"",
			unit_entries:[],
			start_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			end_date 	: aux_date.getFullYear()+'-'+("0" + (aux_date.getMonth() + 1)).slice(-2)+'-'+("0" + aux_date.getDate()).slice(-2),
			columns:[]
		}
	}

	componentDidMount(){

		this.props.socket.onerror = (event)=> {
			console.log(event);
		};

		this.props.socket.onmessage = (event) => {
		    var res = JSON.parse(event.data);
		    if(res.Error !== undefined){
		    	swal('¡Error!', res.Error, 'error');
		    }
		    console.log(res);
		}

		this.getList('inicial');

		fetch(Config.default.apiGateway.URL+'list_show?option=list_key&search=UNIT_INCIDENTS',{ 
	        method: 'get',
	        headers: new Headers({
	           'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
	           'Accept': 'application/json',
	            'Content-Type': 'application/json',
	        })
      	})
      	.then(response => {
      		if(response.ok){
      			return response.json();
      		}else{
      			response.text().then((msg)=>{
      				swal('Error', msg, 'error');
      			});
      		}   		
      	}).then(response => {
        	if(response !== undefined){

          		this.setState({ columns: response });
        	}
      	});
	}

	showColumn(column_name){
      	for(var i =0; i < this.state.columns.length;i++){
  			if(this.state.columns[i]=== column_name){
          		return false;
        	}
      	}

	    return true;
  	}

	getList(inicial){
		this.props.waiting.handleShow('Cargando...');

		var apiUrl = 'unit_incidents?start_date=&end_date=&hf_id='+sessionStorage.getItem('health_facilities_id');

		if(inicial === undefined){
			apiUrl = 'unit_incidents?start_date='+this.state.start_date+'&end_date='+this.state.end_date+
						'&hf_id='+sessionStorage.getItem('health_facilities_id');
		}


		fetch(Config.default.apiGateway.URL+apiUrl, {
			method: 'get',
			headers: new Headers({
				'Authorization' : 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({unit_entries:response})
			}
		});
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});
	}

	printDiscarUnit(e,folio){
		this.printFolioPDF(folio)
	}

	async printFolioPDF(folio){
		this.waiting_modal.handleShow('Imprimiendo...');
					
		var obj ={};
		obj.health_facilities_id = parseInt(sessionStorage.getItem("health_facilities_id"),10);
		obj.id = folio;
		obj.file_type = "discard_units";
		obj.nEtiqueta = [0];

		var type = await this.props.getDocumentType(obj.file_type);

		var document;
		if(type.print_type === 'template'){
			document = await this.props.printDocumentTemplate(obj, type.print_automatically);
		}else if(type.print_type === 'external'){
			document = await this.props.printDocumentExternal(obj, type.print_automatically);
		}

		if(document !== undefined){
			this.waiting_modal.handleClose();
		}else{
			this.waiting_modal.handleClose();
		}
	
	}

	directPrint(response, label_type){
		//PRINTER
		var reader = new FileReader();
		reader.readAsDataURL(response); 
		reader.onloadend = ()=> {
			var base64data = reader.result;  
			var aux = base64data.split(',');
			this.props.socket.send('{"Operacion":"print", "Type":"'+label_type+'", "File": "'+aux[1]+'"}');
		}
	}

	newEntry(){
		this.props.history.push('/discard_units');
	}

	filter(row){
		var res = true;

		if(row !== null){
			if(
				row.date !== null &&
				row.discard_folio !== null &&
				row.user_name !== null &&
				row.hour !== null
			){
				if(
					row.date.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.discard_folio.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.user_name.indexOf(this.state.filterText.toUpperCase()) !== -1 ||
					row.hour.toString().indexOf(this.state.filterText.toUpperCase()) !== -1 
					
				){
					res = true;
				}else{
					res = false;
				}
			}
		}

		return res;
	}

	onDelete(folio){
		var index = this.state.unit_entries.findIndex(obj => obj.discard_folio === folio);
		var units = '';
		this.state.unit_entries[index].units.map((u, i)=>{
			return i % 6 === 0 ?
				units += u+', <br/>'
			: units += u+','
		});

		
		units = units.substring(0,units.length-1);

		var msg = '<p>Estas seguro que quieres dehacer la baja del folio '+folio+
	        	' y todas sus unidades: '+units+'</p>';
		
		swal({
	        title: '',
	        text: msg,
	        html: true,
	        type: 'warning',
	        showCancelButton: true,
	        confirmButtonColor: '#DD6B55',
	        confirmButtonText: '¡Si, Eliminar!',
	        cancelButtonText: '¡No, Cancelar!',
	        closeOnConfirm: true,
	        closeOnCancel: true
	    }, function (isConfirm) {
	        if (isConfirm) {
	          	this.props.waiting.handleShow('Eliminando...');
				fetch(Config.default.apiGateway.URL+'unit_incidents/delete_by_folio?discard_folio='+folio,{
					method: 'delete',
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');	
						});
					}
				}).then(response => {
					if(response !== undefined){
						this.getList();
						swal('Correcto', 'El registro se elimino correctamente.', 'success');
					}
				})
	        }
	    }.bind(this));
	}

	onViewDetails(id){
		this.modal_info.handleShow(id);
	}

	onUpdate(folio){
		this.props.history.push('/discard_units/'+folio);
	}

	render(){
		const {t} = this.props;
		var session = sessionStorage.getItem('health_facilities_name');
		
		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page" >
						{session} ->
						{t('sidebar.nav.home.MAIN')} -> 
						{t('sidebar.nav.process.MAIN')} ->
						{t('sidebar.nav.process.units.MAIN')}
					</h5>
				</div>
				
				<Help 
					{...this.props}
	                menu={"help_processed"} 
	                submenu={"help_discard_units"}  />
				<form noValidate>
					<div className="col-xs-12 form-group">
						{/*<div className="col-xs-12 col-md-3" style={{padding:'0'}}>
				            <div className="col-xs-12 col-sm-5">
				            	<span className="span-min">Mostrar Desde</span>
				            </div>
				            <div className="col-xs-12 col-sm-7">
				              <input className="form-control" type="date" name="start_date" value={this.state.start_date}
				                onChange={this.handleChange}/>
				            </div>
				        </div>*/}

						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Desde</span>
							<input className="form-control" type="date" name="start_date" id="start_date" 
								onChange={this.handleChange} 
								value={this.state.start_date} autoFocus={true} />
						</div>
						<div className="col-xs-12 col-sm-2">
							<span className="span-min">Fecha Hasta</span>
							<input className="form-control" type="date" name="end_date" id="end_date" 
								onChange={this.handleChange} 
								value={this.state.end_date}  />
						</div>

						<div className="col-xs-12 col-sm-4" style={{marginTop:'10px'}}>
							<button type="button" className="btn btn-info" onClick={()=>this.getList()} 
								style={{fontSize:"14px", marginRight:"5px"}}
								>
								Buscar
							</button>
							<button type="button" className="btn btn-info" onClick={this.newEntry} 
								style={{fontSize:"14px"}}
								disabled={!this.props.task_discard_units.create}>
								Nuevo
							</button>
						</div>
					</div>
					<div className="col-xs-12 form-group">
						<div className="col-xs-12 col-sm-4">
							<input type="text" className="form-control" placeholder="Filtro..." name="filterText" 
								id="filterText" value={this.state.filterText} onChange={this.handleChange} />
						</div>
					</div>
					<div className="col-xs-12">
						<Table responsive hover>
							<thead>
								<tr>
									<th hidden={this.showColumn('FOLIO')}>Folio de Baja</th>
									<th hidden={this.showColumn('DATE_HOUR')}>Fecha y Hora</th>
									<th hidden={this.showColumn('USER')}>Usuario</th>
									<th hidden={this.showColumn('CONTROLS')}>Total Unidades</th>
									<th hidden={this.showColumn('TOT_UNITS')}></th>
								</tr>
							</thead>
							<tbody>
								{this.state.unit_entries.map((unit, i)=>{
									return this.filter(unit) === true ?
										<tr key={i}>
											<td hidden={this.showColumn('FOLIO')}>{unit.discard_folio}</td>
											
											<td hidden={this.showColumn('DATE_HOUR')}>
												{moment(unit.date, 'YYYY-MM-DD').format('DD/MM/YYYY') +' '+ 
												moment(unit.hour, 'HH:mm:ss.sssssss').format('HH:mm')} 
											</td>
											<td hidden={this.showColumn('USER')}>{unit.user_name}</td>
											<td hidden={this.showColumn('TOT_UNITS')}>{unit.tot_units}</td>
											<td hidden={this.showColumn('CONTROLS')}>
												
												<FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} 
													disabled={!this.props.task_discard_units.update}
													onClick={this.onUpdate.bind(this, unit.discard_folio)}> 
													<SvgIcon icon={pencil2} className="icon-align"/>
												</FloatingActionButton>
												<FloatingActionButton backgroundColor={'#ededed'} iconStyle={{height: 33, width: 33}} 
													title="Reimprimir" 
													mini={true} style={{marginLeft:"5px"}} 
													onClick={(e) =>this.printDiscarUnit(e,unit.discard_folio)}>
							                      	<SvgIcon icon={print} className="icon-align"/>
							                    </FloatingActionButton>
							                    <FloatingActionButton backgroundColor={'#ededed'} mini={true} style={{marginLeft:"5px"}} 
													iconStyle={{height: 33, width: 33}} 
													disabled={!this.props.task_discard_units.delete}
													onClick={this.onDelete.bind(this, unit.discard_folio)}>
													<SvgIcon icon={bin} disabled={!this.props.task_discard_units.delete}  className="icon-align"/>
												</FloatingActionButton>
												
											</td>
										</tr>
									: null
								})}
							</tbody>
						</Table>
					</div>
					<WaitingModal {...this.props} onRef={ref => (this.waiting_modal = ref)}/>
				</form>

				
			</div>
		)
	}
}

export default translate('translations') (DiscardUnitsList);